'use client';

import { c as _c } from "react/compiler-runtime";
import type { GiftProductLink } from '../../_components/GiftProductLinkCard';
import { GiftProductLinkCard } from '../../_components/GiftProductLinkCard';
import { HotDealCard } from '../../_components/HotDealCard';
import type { AffiliateEntryPointType } from '../../_hooks/useAffiliateClick';
import { useAffiliateClick } from '../../_hooks/useAffiliateClick';
import type { HotDeal } from '../../_hooks/useHotDeals';
export const PRODUCT_GRID_CLASS_NAME = 'grid grid-cols-3 gap-x-12 gap-y-20 px-20 xl:grid-cols-4';
export type MerchantProductCardProps = {
  hotDeal: HotDeal;
  giftProduct?: undefined;
} | {
  hotDeal?: undefined;
  giftProduct: GiftProductLink;
};
export const MerchantProductCard = t0 => {
  const $ = _c(25);
  const {
    hotDeal,
    giftProduct,
    entryPointType: t1
  } = t0;
  const entryPointType = t1 === undefined ? "PRODUCT_TAB" : t1;
  const {
    startAffiliateClick
  } = useAffiliateClick();
  if (hotDeal) {
    let t2;
    if ($[0] !== entryPointType || $[1] !== hotDeal.affiliateHotDealId || $[2] !== hotDeal.appGuideModalPolicy || $[3] !== hotDeal.appGuideModalText || $[4] !== hotDeal.logoImageUrl || $[5] !== hotDeal.merchantCode || $[6] !== hotDeal.merchantName || $[7] !== startAffiliateClick) {
      t2 = () => startAffiliateClick({
        target: {
          type: "hotDeal",
          affiliateHotDealId: hotDeal.affiliateHotDealId
        },
        entryPointType,
        appGuideModalPolicy: hotDeal.appGuideModalPolicy,
        guide: {
          merchantCode: hotDeal.merchantCode,
          merchantName: hotDeal.merchantName ?? "",
          logoImageUrl: hotDeal.logoImageUrl ?? "",
          modalText: hotDeal.appGuideModalText,
          showDetailLink: true
        }
      });
      $[0] = entryPointType;
      $[1] = hotDeal.affiliateHotDealId;
      $[2] = hotDeal.appGuideModalPolicy;
      $[3] = hotDeal.appGuideModalText;
      $[4] = hotDeal.logoImageUrl;
      $[5] = hotDeal.merchantCode;
      $[6] = hotDeal.merchantName;
      $[7] = startAffiliateClick;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== hotDeal || $[10] !== t2) {
      t3 = <HotDealCard hotDeal={hotDeal} onSelect={t2} />;
      $[9] = hotDeal;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  let t2;
  if ($[12] !== entryPointType || $[13] !== giftProduct.affiliateGiftProductLinkId || $[14] !== giftProduct.appGuideModalPolicy || $[15] !== giftProduct.appGuideModalText || $[16] !== giftProduct.logoImageUrl || $[17] !== giftProduct.merchantCode || $[18] !== giftProduct.merchantName || $[19] !== giftProduct.openMode || $[20] !== startAffiliateClick) {
    t2 = () => startAffiliateClick({
      target: {
        type: "giftProductLink",
        affiliateGiftProductLinkId: giftProduct.affiliateGiftProductLinkId
      },
      entryPointType,
      appGuideModalPolicy: giftProduct.appGuideModalPolicy,
      openMode: giftProduct.openMode,
      guide: {
        merchantCode: giftProduct.merchantCode,
        merchantName: giftProduct.merchantName,
        logoImageUrl: giftProduct.logoImageUrl,
        modalText: giftProduct.appGuideModalText,
        showDetailLink: false
      }
    });
    $[12] = entryPointType;
    $[13] = giftProduct.affiliateGiftProductLinkId;
    $[14] = giftProduct.appGuideModalPolicy;
    $[15] = giftProduct.appGuideModalText;
    $[16] = giftProduct.logoImageUrl;
    $[17] = giftProduct.merchantCode;
    $[18] = giftProduct.merchantName;
    $[19] = giftProduct.openMode;
    $[20] = startAffiliateClick;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  let t3;
  if ($[22] !== giftProduct || $[23] !== t2) {
    t3 = <GiftProductLinkCard product={giftProduct} onSelect={t2} />;
    $[22] = giftProduct;
    $[23] = t2;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  return t3;
};